export const SYNC_TIME_PERIOD = 5
